module.exports = __webpack_public_path__ + "static/media/cpb-final-2.b53c68a3.jpg";